export function checkDesktop() {
    //use large media query to distinguish between "desktop" and "mobile"
    const largeQuery = window.matchMedia('(min-width: 992px)').matches;
    return largeQuery;
}
